(function initCookieStorePolyfill() {
  if (typeof window === "undefined") {
    return;
  }
  if ("cookieStore" in window) {
    return;
  }

  class CookieStorePolyfill extends EventTarget {
    private lastCookies: Map<string, string>;

    constructor() {
      super();
      this.lastCookies = this.parseCookies(document.cookie);
      this.startPolling();
    }

    private parseCookies(cookieString: string): Map<string, string> {
      const map = new Map<string, string>();

      if (!cookieString) {
        return map;
      }

      for (const pair of cookieString.split(";")) {
        const [rawName, ...rest] = pair.split("=");

        if (!rawName) {
          continue;
        }

        const name = rawName.trim();
        const value = rest.join("=").trim();

        if (!name) {
          continue;
        }

        map.set(decodeURIComponent(name), decodeURIComponent(value));
      }

      return map;
    }

    private startPolling() {
      window.setInterval(() => {
        const currentCookies = this.parseCookies(document.cookie);
        const changed: CookieListItem[] = [];
        const deleted: CookieListItem[] = [];

        for (const [name, value] of currentCookies) {
          const previous = this.lastCookies.get(name);
          if (previous !== value) {
            changed.push({ name, value });
          }
        }

        for (const [name, value] of this.lastCookies) {
          if (!currentCookies.has(name)) {
            deleted.push({ name, value });
          }
        }

        if (changed.length || deleted.length) {
          const event = new Event("change") as CookieChangeEvent;
          (event as any).changed = changed;
          (event as any).deleted = deleted;
          this.dispatchEvent(event);
        }

        this.lastCookies = currentCookies;
      }, 1000);
    }
  }

  (window as any).cookieStore = new CookieStorePolyfill();
})();
